export { default as Header } from "./header";
export { default as Hero } from "./hero";
export { default as AboutBasicTraning } from "./about-basic-traning";
// export { default as HowWorks } from "./how-it-works";
export { default as UpcomingCourse } from "./upcoming-course";
export { default as WhyChooseUs } from "./why-choose-us";
// export { default as OurStory } from "./our-story";
export { default as UpcomingEvents } from "./upcoming-events";
export { default as Faq } from "./faq";
export * from "./provider";
export { default as RecommendUs } from "./recommend-us";
export { default as Footer } from "./footer";
export { default as Enroll } from "./enroll";
export { default as Modal } from "./modal";
export { default as NotifyMe } from "./modal/notify-me";
export { default as TrainingSlot } from "./modal/training-slot";
export { default as AuthRightSidebar } from "./auth-right-sidebar";
export { default as CourseHeader } from "./header/course-header";
export { default as LogOutConfirmation } from "./modal/log-out-confirmation";
export { default as DownloadCertificate } from "./modal/download-certificate";
export { default as QuizResult } from "./modal/quiz-result";
export { default as VerificationLinkSent } from "./modal/verification-link-sent";
export { default as Loader } from "./loader";
export { default as CourseNotFound } from "./not-found/course";
export { default as SessionProvider } from "./session-provider";
export { default as FilePreview } from "./file-preview";
export { default as VideoPlayer } from "./video-player";
export { default as LessonNavigation } from "./lesson-navigation";
export { default as LessonLoader } from "./loader/lesson-loader";
export { default as CourseNotStarted } from "./not-found/course";
